export const MUTATION_TYPES = {
  ADD_PORTFOLIO_KEYWORD: 'PORTFOLIOS/ADD_PORTFOLIO_KEYWORD',
  REMOVE_PORTFOLIO_KEYWORD: 'PORTFOLIOS/REMOVE_PORTFOLIO_KEYWORD',
  SET_ACTIVE_FILTERS: 'PORTFOLIOS/SET_ACTIVE_FILTERS',
}

export const mutations = {
  // Keywords
  [MUTATION_TYPES.ADD_PORTFOLIO_KEYWORD] (state, keyword) {
    const existingEntry = state.portfolioKeywords.find(k => k.value === keyword.value && k.facet === keyword.facet)
    if (!existingEntry) {
      state.portfolioKeywords.push(keyword)
    }
  },

  [MUTATION_TYPES.REMOVE_PORTFOLIO_KEYWORD] (state, keyword) {
    // Note: clear by object equality
    state.portfolioKeywords = state.portfolioKeywords.filter(k => k.value !== keyword.value)
  },

  // The keyword chips above are purely visual and already survive navigation
  // as a Vuex singleton, but the actual filter *values* used to build the
  // portfolio query live in PortfolioFilters.vue's local component data,
  // which resets every time that component is recreated. Persisting them
  // here lets the filters component rehydrate itself on mount.
  [MUTATION_TYPES.SET_ACTIVE_FILTERS] (state, filters) {
    state.activeFilters = { ...state.activeFilters, ...filters }
  },
}

export const roles = {
  EXPLORER: 'explorer',
  CONTRIBUTOR: 'contributor',
}

export const getters = {
  activePortfolioKeywords (state) {
    return state.portfolioKeywords
  },
  activePortfolioFilters (state) {
    return state.activeFilters
  },
  personalPortfolio (state) {
    var portfolios = window.PORTFOLIOS || []

    return portfolios.find(portfolio => {
      return portfolio.name == 'Personal portfolio'
    })
  },
}

export default {
  state: {
    portfolioKeywords: [],
    activeFilters: {
      access: null,
      createdByIds: [],
      sortUsage: null,
      sortActivity: null,
    },
  },
  getters,
  mutations,
}
